<div class="filters" *ngIf="dropdownItems">
  <mat-form-field>
    <mat-label>{{ searchLabel }}</mat-label>
    <input data-testid="search-user" matInput [formControl]="$any(filtersFormGroup.get('searchInput'))" type="text" />
  </mat-form-field>
  <app-select
    [control]="filtersFormGroup.get('is_active')"
    [items]="dropdownItems.yesOrNo"
    [multiple]="true"
    [disableMultipleTypeahead]="true"
    [labelKey]="'admin/users/is_active'"
    [localStorageKey]="'users-field-active-' + companyId"></app-select>
  <app-select
    [control]="filtersFormGroup.get('is_admin')"
    [items]="dropdownItems.yesOrNo"
    [multiple]="true"
    [disableMultipleTypeahead]="true"
    [labelKey]="'admin/users/is_admin'"
    [localStorageKey]="'users-field-admin-' + companyId"></app-select>
  <app-select
    *ngIf="routingTagExists"
    [control]="filtersFormGroup.get('teams')"
    [items]="dropdownItems.teams"
    [multiple]="true"
    [disableMultipleTypeahead]="true"
    [labelKey]="'users_roles/teams'"
    [localStorageKey]="'users-field-teams-' + companyId"></app-select>
  <app-select
    [control]="filtersFormGroup.get('roles')"
    [items]="dropdownItems.roles"
    [multiple]="true"
    [disableMultipleTypeahead]="true"
    [labelKey]="'users_roles/roles'"
    [localStorageKey]="'users-field-roles-' + companyId"></app-select>
</div>
<table
  mat-table
  [dataSource]="dataSource"
  matSort
  (matSortChange)="sortData($event)"
  matSortActive="email"
  matSortDirection="asc">
  <!-- ID Column -->
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="admin/users/email"></span></th>
    <td mat-cell *matCellDef="let row">
      <span (click)="userSelected.emit(row)" class="users-roles-table-link">{{ row.email }}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="common/name"></span></th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>
  <ng-container matColumnDef="is_active">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="admin/users/is_active"></span></th>
    <td mat-cell *matCellDef="let row">{{ row.isActiveLabel }}</td>
  </ng-container>
  <ng-container matColumnDef="is_admin">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="admin/users/is_admin"></span></th>
    <td mat-cell *matCellDef="let row">{{ row.isAdminLabel }}</td>
  </ng-container>
  <ng-container matColumnDef="teams">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="users_roles/teams"></span></th>
    <td mat-cell *matCellDef="let row">
      <div class="list">
        <span
          class="users-roles-table-link"
          *ngFor="let team of row.teams"
          (click)="teamSelected.emit({ id: team.id })">
          {{ team?.label }}
        </span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="roles">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="users_roles/roles"></span></th>
    <td mat-cell *matCellDef="let row">
      <div class="list">
        <span
          class="users-roles-table-link"
          *ngFor="let role of row.roles"
          (click)="roleSelected.emit({ id: role.id })">
          {{ role?.label }}
        </span>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <!-- Row shown when there is no matching data. -->
  <tr class="mat-row" *matNoDataRow>
    <td
      *ngIf="loading; else noResults"
      class="mat-cell"
      [attr.colspan]="displayedColumns.length"
      translate="loading"></td>
    <ng-template #noResults>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" translate="no-results"></td>
    </ng-template>
  </tr>
</table>

<mat-paginator [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
